const defaultState = {
  challengesAlgolia: [],
  companiesAlgolia: [],
  studentsAlgolia: [],
  clientsAlgolia: [],
};

export default (state = defaultState, action) => {
  let newState = Object.assign({}, state);
  switch (action.type) {
    case "SET_CHALLENGE_RESULTS":
      newState.challengesAlgolia = action.payload;
      return newState;
    case "SET_COMPANY_RESULTS":
      newState.companiesAlgolia = action.payload;
      return newState;
    case "SET_PROFILE_RESULTS":
      newState.studentsAlgolia = action.payload;
      return newState;
    case "SET_CLIENT_RESULTS":
      newState.clientsAlgolia = action.payload;
      return newState;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/search.js